export default __webpack_public_path__ + "static/media/flutter.c01689b8.png";